import FAQPersonalPricing from "./footer/faq";
import FooterPersonalPrice from "./footer/footercomponent";

const FooterPricing = () => {
  return (
    <>
      <FooterPersonalPrice />
      <FAQPersonalPricing />
    </>
  );
};

export default FooterPricing;
